module.exports = __webpack_public_path__ + "media/video-m.58e865f3.mp4";